export default __webpack_public_path__ + "static/media/nav-email-outline.e3f92952.svg";